import { Pipe, PipeTransform } from '@angular/core';
import { translateCategory } from '../mappers/enum-translation-mapper';
import { IncidentCategory } from 'src/app/features/incidents/incident-models';

@Pipe({
  name: 'translateIncidentCategoryEnum',
})
export class TranslateIncidentCategoryEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const problemTypeEnum = element as { name: string; index: number };
        problemTypeEnum.name = translateCategory(problemTypeEnum.index as unknown as IncidentCategory);
      });
      return value;
    }
    return translateCategory(value);
  }
}
